<!-- App.vue -->
<template>
    <div :class="layoutContainerClass" @click="onDocumentClick">
        <div class="layout-main">
            <AppTopBar
                v-show="$router.currentRoute.value.fullPath !== '/listeapertemartina' && $router.currentRoute.value.fullPath !== '/consegne'"
                :items="menu" :menuMode="menuMode" :colorScheme="colorScheme" :menuActive="menuActive"
                :topbarMenuActive="topbarMenuActive" :activeInlineProfile="activeInlineProfile"
                @topbar-item-click="onTopbarItemClick" @menubutton-click="onMenuButtonClick"
                @sidebar-mouse-over="onSidebarMouseOver" @sidebar-mouse-leave="onSidebarMouseLeave"
                @toggle-menu="onToggleMenu" @change-inlinemenu="onChangeActiveInlineMenu" @menu-click="onMenuClick"
                @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick" />

            <AppMenu
                v-show="$router.currentRoute.value.fullPath !== '/listeapertemartina' && $router.currentRoute.value.fullPath !== '/consegne'"
                :model="menu" :menuMode="menuMode" :colorScheme="colorScheme" :menuActive="menuActive"
                :sidebarActive="sidebarActive" :sidebarStatic="sidebarStatic" :pinActive="pinActive"
                :activeInlineProfile="activeInlineProfile" @sidebar-mouse-over="onSidebarMouseOver"
                @sidebar-mouse-leave="onSidebarMouseLeave" @toggle-menu="onToggleMenu"
                @change-inlinemenu="onChangeActiveInlineMenu" @menu-click="onMenuClick"
                @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick" />

            <!-- <AppBreadcrumb
        :menuMode="menuMode"
        v-model:searchActive="searchActive"
        v-model:searchClick="searchClick"
        @menubutton-click="onMenuButtonClick"
        @rightmenu-button-click="onRightMenuButtonClick"
      /> -->

            <div class="layout-main-content">
                <router-view />
            </div>

            <AppFooter :colorScheme="colorScheme" />
        </div>

        <AppRightMenu :rightMenuActive="rightMenuActive" @rightmenu-click="onRightMenuClick"
            @rightmenu-active="onChangeRightMenuActive" />

        <AppConfig
            v-show="$router.currentRoute.value.fullPath !== '/listeapertemartina' && $router.currentRoute.value.fullPath !== '/consegne'"
            v-model:menuMode="menuMode" :theme="theme" :componentTheme="componentTheme" :colorScheme="colorScheme"
            :configActive="configActive" :configClick="configClick" @config-button-click="onConfigButtonClick"
            @config-click="onConfigClick" @change-color-scheme="onChangeColorScheme"
            @change-component-theme="onChangeComponentTheme" @change-menu-theme="onChangeMenuTheme"
            @change-menu-mode="onChangeMenuMode" />
    </div>
</template>

<script>
    import AppTopBar from './AppTopbar.vue'
    import AppMenu from './AppMenu.vue'
    import AppRightMenu from './AppRightMenu.vue'
    import AppFooter from './AppFooter.vue'
    // import AppBreadcrumb from "./AppBreadcrumb.vue";
    import AppConfig from './AppConfig.vue'
    import EventBus from './event-bus'
    import VueJwtDecode from 'vue-jwt-decode'
    import routePermissionsMap, { routeUserPermissionsMap } from './routePermissionsMap'


    export default {
        emits: ['layout-mode-change', 'menu-theme', 'layoutModeChange', 'sidebar-mouse-over', 'sidebar-mouse-leave', 'change-color-scheme', 'change-component-theme', 'change-menu-theme', 'change-inlinemenu'],
        props: {
            colorScheme: String,
            topbarTheme: String,
            theme: String,
            componentTheme: String,
        },
        data() {
            return {
                search: false,
                searchClick: false,
                searchActive: false,
                menuMode: 'overlay',
                menuActive: false,
                activeInlineProfile: false,
                inlineMenuClick: false,
                overlayMenuActive: false,
                topbarMenuActive: false,
                topbarItemClick: false,
                sidebarActive: false,
                sidebarStatic: false,
                pinActive: false,
                staticMenuDesktopInactive: false,
                staticMenuMobileActive: false,
                rightMenuClick: false,
                rightMenuActive: false,
                configActive: false,
                configClick: false,
                menu: [
                    {
                        label: 'Condominio e Contatori',
                        icon: 'pi pi-fw pi-user',
                        items: [
                            {
                                label: 'Gestione Contatori',
                                icon: 'pi pi-fw pi-bolt',
                                to: '/gestione-contatori',
                            },
                        ],
                    },
                    {
                        label: 'Gestione Aziendale',
                        icon: 'pi pi-fw pi-sitemap',
                        items: [
                            {
                                label: 'Gestione Utenti',
                                icon: 'pi pi-fw pi-users',
                                to: '/gestioneutenti',
                            },
                            {
                                label: 'Gestione Permessi',
                                icon: 'pi pi-fw pi-lock',
                                to: '/gestionepermessi',
                            },
                            {
                                label: 'Risorse Aziendali',
                                icon: 'pi pi-fw pi-briefcase',
                                to: '/risorseaziendali',
                            },
                        ],
                    },
                    {
                        label: 'Cash Flow',
                        icon: 'pi pi-fw pi-dollar',
                        items: [
                            {
                                label: 'Budget Cash Flow',
                                icon: 'pi pi-fw pi-chart-bar',
                                to: '/budgetcashflow',
                            },
                            {
                                label: 'Ordini Aperti Fornitore',
                                icon: 'pi pi-fw pi-shopping-bag',
                                to: '/statoordinifornitoriconsegne',
                            },
                            {
                                label: 'Ordini Inevasi Per Marca',
                                icon: 'pi pi-fw pi-shopping-bag',
                                to: '/ordiniinevasipermarca',
                            },
                         /*   {
                                label: 'Ordini Aperti Clienti',
                                icon: 'pi pi-fw pi-shopping-cart',
                                to: '/ordiniaperticlientiperdocumentocashflow',
                            },*/
                            {
                                label: 'Scadenze Aperte Fornitore',
                                icon: 'pi pi-fw pi-calendar-minus',
                                to: '/scadenzefinemesefornitore',
                            },
                            {
                                label: 'Scadenze AJAX e Budget',
                                icon: 'pi pi-fw pi-calendar',
                                to: '/scadenzarioajax',
                            },
                            {
                                label: 'Centro Di Costo',
                                icon: 'pi pi-fw pi-chart-pie',
                                to: '/centrodicosto',
                            },
                            {
                                label: 'Calcolo Iva',
                                icon: 'pi pi-fw pi-tag',
                                to: '/calcoloiva',
                            },
                        ],
                    },
                    {
                        label: 'Amministrazione',
                        icon: 'pi pi-fw pi-wallet',
                        items: [
                            {
                                label: 'Banche e Tesoreria',
                                icon: 'pi pi-fw pi-building',
                                items: [
                                    {
                                        label: 'Flussi Bancari',
                                        icon: 'pi pi-fw pi-chart-line',
                                        to: '/flussibancari',
                                    },
                                    {
                                        label: 'Saldi Banche',
                                        icon: 'pi pi-fw pi-wallet',
                                        to: '/saldibanche',
                                    },
                                    {
                                        label: 'Anticipo Riba',
                                        icon: 'pi pi-fw pi-upload',
                                        to: '/anticipobancheriba',
                                    },
                                    {
                                        label: 'Copertura Assegni Linee di Credito',
                                        icon: 'pi pi-fw pi-credit-card',
                                        to: '/coperturacreditoassegni',
                                    },
                                ],
                            },
                            {
                                label: 'Crediti e Clienti',
                                icon: 'pi pi-fw pi-users',
                                items: [
                                    {
                                        label: 'Stato Fidi Clienti',
                                        icon: 'pi pi-fw pi-chart-bar',
                                        to: '/statofidiclienti',
                                    },
                                    {
                                        label: 'Sospesi per Agente',
                                        icon: 'pi pi-fw pi-exclamation-circle',
                                        to: '/sospesiperagente',
                                    },
                                    {
                                        label: 'Calcolo Costo Ritardo Pagamento',
                                        icon: 'pi pi-fw pi-clock',
                                        to: '/calcolocostodso',
                                    },
                                    {
                                        label: 'Calcolo Costo DSO Ideale',
                                        icon: 'pi pi-fw pi-calendar-times',
                                        to: '/calcolocostodsoideale',
                                    },
                                ],
                            },
                            {
                                label: 'Scadenze e Pagamenti',
                                icon: 'pi pi-fw pi-calendar',
                                items: [
                                    {
                                        label: 'Match Scadenze Excel',
                                        icon: 'pi pi-fw pi-file-excel',
                                        to: '/matchscadenzeexcel',
                                    },
                                    {
                                        label: 'Crea Scadenza Ricorrente',
                                        icon: 'pi pi-fw pi-sync',
                                        to: '/creascadenzaricorrente',
                                    },
                                    {
                                        label: 'Pagamenti Ricorrenti',
                                        icon: 'pi pi-fw pi-replay',
                                        to: '/pagamentiricorrenti',
                                    },
                                ],
                            },
                            {
                                label: 'Assicurazioni',
                                icon: 'pi pi-fw pi-shield',
                                items: [
                                    {
                                        label: 'Lista Sinistri Aperti',
                                        icon: 'pi pi-fw pi-exclamation-triangle',
                                        to: '/listasinistriassicurativi',
                                    },
                                    {
                                        label: 'Gestione Assicuratori',
                                        icon: 'pi pi-fw pi-briefcase',
                                        to: '/gestioneassicuratori',
                                    },
                                ],
                            },
                            /*  {
                                  label: 'SVD - FIN.SENZA VINCOLO DESTINAZIONE',
                                  icon: 'pi pi-fw pi-shield',
                                  items: [
                                      {
                                          label: 'Gestione SVD',
                                          icon: 'pi pi-fw pi-shield',
                                          to: '/masterfinanziamenti',
                                      },
                                  ],
                              },*/
                            /*{
                                label: 'Finanziamenti',
                                icon: 'pi pi-fw pi-euro',
                                items: [
                                    {
                                        label: 'Finanziamenti',
                                        icon: 'pi pi-fw pi-euro',
                                        to: '/finanziamenti',
                                    },
                                    {
                                        label: 'Manutenzione Finanziamenti',
                                        icon: 'pi pi-fw pi-euro',
                                        to: '/manutenzionefinanziamenti',
                                    },
                                ],
                            },*/
                            /* {
                                 label: 'Manutenzione',
                                 icon: 'pi pi-fw pi-wallet',
                                 items: [
                                     {
                                         label: 'Manutenzione Banche',
                                         icon: 'pi pi-fw pi-euro',
                                         to: '/manutenzionebanche',
                                     },
                                 ],
                             },*/
                        ],
                    },
                    {
                        label: 'Anagrafiche',
                        icon: 'pi pi-fw pi-user',
                        items: [
                            {
                                label: 'Clienti',
                                icon: 'pi pi-fw pi-users',
                                items: [
                                    {
                                        label: 'Anagrafiche Clienti',
                                        icon: 'pi pi-fw pi-user',
                                        to: '/anagrafiche',
                                    },
                                    {
                                        label: 'Clienti Inattivi',
                                        icon: 'pi pi-fw pi-user-times',
                                        to: '/clientiinattivi',
                                    },
                                    {
                                        label: 'Gestione Alert Clienti',
                                        icon: 'pi pi-fw pi-bell',
                                        to: '/gestione-alert-clienti',
                                    },
                                ],
                            },
                            {
                                label: 'Fornitori',
                                icon: 'pi pi-fw pi-truck',
                                items: [
                                    {
                                        label: 'Anagrafiche Fornitori',
                                        icon: 'pi pi-fw pi-briefcase',
                                        to: '/fornitori',
                                    },
                                ],
                            },
                        ],
                    },

                    {
                        label: 'Commerciale',
                        icon: 'pi pi-fw pi-shopping-bag',
                        items: [
                            {
                                label: 'Accordi e Condizioni',
                                icon: 'pi pi-fw pi-file-edit',
                                items: [
                                    {
                                        label: 'Vedi Lettere Premio Clienti',
                                        icon: 'pi pi-fw pi-envelope',
                                        to: '/dashboardletterepremioclienti',
                                    },
                                    {
                                        label: 'Crea Lettere Premio Clienti',
                                        icon: 'pi pi-fw pi-plus-circle',
                                        to: '/crealetterepremioclienti',
                                    },
                                    {
                                        label: 'Manutenzione Sconti Clienti',
                                        icon: 'pi pi-fw pi-tag',
                                        to: '/manutenzionesconticlienti',
                                    },
                                ],
                            },
                            {
                                label: 'Preventivi',
                                icon: 'pi pi-fw pi-file',
                                items: [
                                    {
                                        label: 'Situazione Preventivi',
                                        icon: 'pi pi-fw pi-list',
                                        to: '/agentedashboardticket',
                                    },
                                   
                                ],
                            },
                            {
                                label: 'Articoli',
                                icon: 'pi pi-fw pi-box',
                                items: [
                                    {
                                        label: 'Gestione Articoli',
                                        icon: 'pi pi-fw pi-table',
                                        to: '/articolids',
                                    },
                                    {
                                        label: 'Richieste Articoli da DSWeb',
                                        icon: 'pi pi-fw pi-send',
                                        to: '/richiestediarticolidadsweb',
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        label: 'Risorse Umane',
                        icon: 'pi pi-fw pi-id-card',
                        items: [
                            {
                                label: 'Missioni',
                                icon: 'pi pi-fw pi-map-marker',
                                items: [
                                    {
                                        label: 'Inserisci Missioni',
                                        icon: 'pi pi-fw pi-plus',
                                        to: '/inserimentomissioni',
                                    },
                                    {
                                        label: 'Manutenzione Parco Auto',
                                        icon: 'pi pi-fw pi-car',
                                        to: '/parcoauto',
                                    },
                                ],
                            },
                            {
                                label: 'Permessi e Ferie',
                                icon: 'pi pi-fw pi-calendar-plus',
                                items: [
                                    {
                                        label: 'Richiesta Permessi e Ferie',
                                        icon: 'pi pi-fw pi-send',
                                        to: '/richiestapermessieferie',
                                    },
                                    {
                                        label: 'Approvazione Permessi e Ferie',
                                        icon: 'pi pi-fw pi-check',
                                        to: '/approvezionepermessieferie',
                                    },
                                ],
                            },
                            {
                                label: 'Check Matricole',
                                icon: 'pi pi-fw pi-check-circle',
                                to: '/checkmatricoleufficiotecnico',
                            },
                        ],
                    },
                    {
                        label: 'Corrieri e Consegne',
                        icon: 'pi pi-fw pi-truck',
                        items: [
                            {
                                label: 'Consegne',
                                icon: 'pi pi-fw pi-box',
                                to: '/consegne',
                            },
                            {
                                label: 'Gestione Corrieri',
                                icon: 'pi pi-fw pi-users',
                                to: '/corrieri',
                            },
                        ],
                    },
                    {
                        label: 'Magazzini',
                        icon: 'pi pi-fw pi-building',
                        items: [
                            {
                                label: 'Gestione Generale',
                                icon: 'pi pi-fw pi-cog',
                                items: [
                                    {
                                        label: 'Valorizzazione Magazzino',
                                        icon: 'pi pi-fw pi-euro',
                                        to: '/valorizzazionimagazzino',
                                    },
                                    {
                                        label: 'Verifica Anomalie',
                                        icon: 'pi pi-fw pi-exclamation-triangle',
                                        to: '/verificaanomalie',
                                    },
                                    {
                                        label: 'Gestione Inventario',
                                        icon: 'pi pi-fw pi-list',
                                        to: '/gestioneinventario',
                                    },
                                    {
                                        label: 'Gestione Trasferimenti',
                                        icon: 'pi pi-fw pi-replay',
                                        to: '/gestionetrasferimenti',
                                    },
                                    {
                                        label: 'Controllo Carichi',
                                        icon: 'pi pi-fw pi-download',
                                        to: '/gestionecarichimagazzino',
                                    },
                                    {
                                        label: 'Cruscotto Missioni',
                                        icon: 'pi pi-fw pi-truck',
                                        to: '/cruscottomissioni',
                                    },
                                ],
                            },
                            {
                                label: 'Ubicazioni',
                                icon: 'pi pi-fw pi-th-large',
                                items: [
                                    {
                                        label: 'Picking attive',
                                        icon: 'pi pi-fw pi-list',
                                        to: '/picking-ubicazioni',
                                    },
                                    {
                                        label: 'Scorte per ubicazione',
                                        icon: 'pi pi-fw pi-map',
                                        to: '/scorte-picking-per-ubicazione',
                                    },
                                    {
                                        label: 'Storico movimenti',
                                        icon: 'pi pi-fw pi-history',
                                        to: '/storico-movimenti-ubicazioni',
                                    },
                                ],
                            },
                            {
                                label: 'Martina Franca',
                                icon: 'pi pi-fw pi-map-marker',
                                items: [
                                    {
                                        label: 'Ordini Evadibili Amministrazione',
                                        icon: 'pi pi-fw pi-check-square',
                                        to: '/ordinievadibilimf',
                                    },
                                    {
                                        label: 'Ordini Evadibili Gestore',
                                        icon: 'pi pi-fw pi-check',
                                        to: '/ordinievadibilimfGestore',
                                    },
                                    {
                                        label: 'Lavorato del Giorno',
                                        icon: 'pi pi-fw pi-calendar',
                                        to: '/lavoratodelgiornomf',
                                    },
                                    {
                                        label: 'Liste di Prelievo Aperte',
                                        icon: 'pi pi-fw pi-shopping-cart',
                                        to: '/listeapertemartina',
                                    },
                                    {
                                        label: 'Valorizzazione Banco',
                                        icon: 'pi pi-fw pi-dollar',
                                        to: '/consegnealbancomartinafranca',
                                    },
                                ],
                            },
                            {
                                label: 'Casarano',
                                icon: 'pi pi-fw pi-map-marker',
                                items: [
                                    {
                                        label: 'Ordini Inevasi',
                                        icon: 'pi pi-fw pi-times-circle',
                                        to: '/ordiniinevasicasarano',
                                    },
                                    {
                                        label: 'Liste di Prelievo Aperte',
                                        icon: 'pi pi-fw pi-shopping-cart',
                                        to: '/listeapertecasarano',
                                    },
                                ],
                            },
                            {
                                label: 'Lecce',
                                icon: 'pi pi-fw pi-map-marker',
                                items: [
                                    {
                                        label: 'Ordini Inevasi',
                                        icon: 'pi pi-fw pi-times-circle',
                                        to: '/ordiniinevasilecce',
                                    },
                                    {
                                        label: 'Liste di Prelievo Aperte',
                                        icon: 'pi pi-fw pi-shopping-cart',
                                        to: '/listeapertelecce',
                                    },
                                ],
                            },
                            {
                                label: 'Modugno',
                                icon: 'pi pi-fw pi-map-marker',
                                items: [
                                    {
                                        label: 'Ordini Inevasi',
                                        icon: 'pi pi-fw pi-times-circle',
                                        to: '/ordiniinevasimodugno',
                                    },
                                    {
                                        label: 'Liste di Prelievo Aperte',
                                        icon: 'pi pi-fw pi-shopping-cart',
                                        to: '/listeapertemodugno',
                                    },
                                ],
                            },
                            {
                                label: 'Oria',
                                icon: 'pi pi-fw pi-map-marker',
                                items: [
                                    {
                                        label: 'Ordini Inevasi',
                                        icon: 'pi pi-fw pi-times-circle',
                                        to: '/ordiniinevasioria',
                                    },
                                    {
                                        label: 'Liste di Prelievo Aperte',
                                        icon: 'pi pi-fw pi-shopping-cart',
                                        to: '/listeaperteoria',
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        label: 'Statistiche e Report',
                        icon: 'pi pi-fw pi-chart-bar',
                        items: [
                            {
                                label: 'Analisi Direzionale',
                                icon: 'pi pi-fw pi-briefcase',
                                items: [
                                    {
                                        label: 'Venduto Prodotti Anno Corrente',
                                        icon: 'pi pi-fw pi-chart-line',
                                        to: '/vendutoprodottiannocorrente',
                                    },
                                    {
                                        label: 'Statistiche Acquisti Articoli',
                                        icon: 'pi pi-fw pi-shopping-bag',
                                        to: '/statisticheacquisti',
                                    },
                                    {
                                        label: 'Storico Fatturati',
                                        icon: 'pi pi-fw pi-clock',
                                        to: '/storicovendutofatturatoagenti',
                                    },
                                    {
                                        label: 'Top 50 Clienti per Brand',
                                        icon: 'pi pi-fw pi-star',
                                        to: '/top50clientiperbrand',
                                    },
                                ],
                            },
                            {
                                label: 'Report Agenti',
                                icon: 'pi pi-fw pi-users',
                                items: [
                                    {
                                        label: 'Fatturato per Clienti',
                                        icon: 'pi pi-fw pi-user',
                                        to: '/fatturatoperclienti',
                                    },
                                    {
                                        label: 'Fatturato Mensile',
                                        icon: 'pi pi-fw pi-calendar',
                                        to: '/fatturatomensile',
                                    },
                                    {
                                        label: 'Storico Fatturato Mensile',
                                        icon: 'pi pi-fw pi-history',
                                        to: '/fatturatomensilemesiscorsi',
                                    },
                                    {
                                        label: 'Fatturato Pivot',
                                        icon: 'pi pi-fw pi-table',
                                        to: '/fatturatopivot',
                                    },
                                ],
                            },
                            {
                                label: 'Report Fotovoltaico',
                                icon: 'pi pi-fw pi-sun',
                                items: [
                                    {
                                        label: 'Fatturato per Clienti',
                                        icon: 'pi pi-fw pi-user',
                                        to: '/fatturatoperclientifotovoltaico',
                                    },
                                    {
                                        label: 'Fatturato Mensile',
                                        icon: 'pi pi-fw pi-calendar',
                                        to: '/fatturatomensilefotovoltaico',
                                    },
                                ],
                            },
                            {
                                label: 'Situazione Ordini',
                                icon: 'pi pi-fw pi-list',
                                items: [
                                    {
                                        label: 'Ordini Inevasi Clienti',
                                        icon: 'pi pi-fw pi-times-circle',
                                        to: '/ordiniinevasiclienti',
                                    },
                                    {
                                        label: 'Ordini Non Evasi Filiali',
                                        icon: 'pi pi-fw pi-exclamation-circle',
                                        to: '/ordininonevasifiliali',
                                    },
                                ],
                            },
                        ],
                    },

                    /* {
                         label: 'Statistiche Generali',
                         icon: 'pi pi-fw pi-box',
                         items: [
                             {
                                 label: 'Doc. Listino Variato',
                                 icon: 'pi pi-fw pi-chart-line',
                                 to: '/statistichedocumentiarca',
                             },
                         ],
                     },*/
                    {
                        label: 'Incassi e Portafogli',
                        icon: 'pi pi-fw pi-money-bill',
                        items: [
                            {
                                label: 'Wizard Incassi',
                                icon: 'pi pi-fw pi-plus-circle',
                                to: '/indexincassi',
                            },
                            {
                                label: 'Wizard Incassi Globale',
                                icon: 'pi pi-fw pi-globe',
                                to: '/incassibanconista',
                            },
                            {
                                label: 'Portafoglio Agenti',
                                icon: 'pi pi-fw pi-briefcase',
                                to: '/portafoglioagenti',
                            },
                            {
                                label: 'Portafoglio Banconisti',
                                icon: 'pi pi-fw pi-users',
                                to: '/portafoglioagentibanco',
                            },
                            {
                                label: 'Portafoglio Acconti',
                                icon: 'pi pi-fw pi-wallet',
                                to: '/portafoglioaccontiagenti',
                            },
                            {
                                label: 'Manutenzione Incassi',
                                icon: 'pi pi-fw pi-cog',
                                to: '/manutenzioneincassi',
                            },
                            {
                                label: 'Manutenzione Acconti',
                                icon: 'pi pi-fw pi-wrench',
                                to: '/manutenzioneacconti',
                            },
                            {
                                label: 'Stato Assicurazione',
                                icon: 'pi pi-fw pi-shield',
                                to: '/statoassicurazioneclienti',
                            },
                        ],
                    },
                    {
                        label: 'Assistenza e Riparazioni',
                        icon: 'pi pi-fw pi-cog',
                        items: [
                            {
                                label: 'Storico Riparazioni',
                                icon: 'pi pi-fw pi-history',
                                to: '/riparazioni',
                            },
                            {
                                label: 'Situazione Fornitori',
                                icon: 'pi pi-fw pi-briefcase',
                                to: '/situazionefornitori',
                            },
                            {
                                label: 'Flow Riparazioni',
                                icon: 'pi pi-fw pi-sitemap',
                                to: '/flowriparazioni',
                            },
                        ],
                    },
                    {
                        label: 'Ticket e Supporto',
                        icon: 'pi pi-fw pi-ticket',
                        items: [
                            {
                                label: 'Lista Ticket',
                                icon: 'pi pi-fw pi-list',
                                to: '/ticketlist',
                            },
                            {
                                label: 'Gestione Email',
                                icon: 'pi pi-fw pi-envelope',
                                to: '/emaildetail',
                            },
                        ],
                    },
                    {
                        label: 'Utility e Strumenti',
                        icon: 'pi pi-fw pi-th-large',
                        items: [
                            {
                                label: 'Stato Robottino',
                                icon: 'pi pi-fw pi-android',
                                to: '/statorobottino',
                            },
                            {
                                label: 'Temperatura Sala Server',
                                icon: 'pi pi-fw pi-chart-line',
                                to: '/temperaturasalaserver',
                            },
                            {
                                label: 'Taglio Barre (DSLab)',
                                icon: 'pi pi-fw pi-bars',
                                to: '/tagliobarre',
                            },
                            {
                                label: 'Configuratore Step',
                                icon: 'pi pi-fw pi-cog',
                                to: '/configuratorestep',
                            },
                        ],
                    },
                    {
                        label: 'Demo e Test',
                        icon: 'pi pi-fw pi-code',
                        items: [
                            {
                                label: 'Table Demo',
                                icon: 'pi pi-fw pi-table',
                                to: '/tabledemo',
                            },
                            {
                                label: 'Presa in Carico',
                                icon: 'pi pi-fw pi-check-square',
                                to: '/presaincaricoriparazione',
                            },
                        ],
                    },
                ],
                routePermissionsMap
            }
        },
        watch: {
            $route() {
                this.menuActive = false
                this.$toast.removeAllGroups()
            },
        },
        methods: {
            onDocumentClick() {
                if (!this.searchClick && this.searchActive) {
                    this.onSearchHide()
                }

                if (!this.topbarItemClick) {
                    this.topbarMenuActive = false
                }

                if (!this.menuClick) {
                    if (this.isHorizontal() || this.isSlim()) {
                        this.menuActive = false
                        EventBus.emit('reset-active-index')
                    }

                    if (this.overlayMenuActive || this.staticMenuMobileActive) {
                        this.overlayMenuActive = false
                        this.staticMenuMobileActive = false
                    }

                    this.hideOverlayMenu()
                    this.unblockBodyScroll()
                }

                if (!this.rightMenuClick) {
                    this.rightMenuActive = false
                }

                if (this.configActive && !this.configClick) {
                    this.configActive = false
                }

                this.topbarItemClick = false
                this.menuClick = false
                this.configClick = false
                this.rightMenuClick = false
                this.searchClick = false
                this.inlineMenuClick = false
            },
            onSearchHide() {
                this.searchActive = false
                this.searchClick = false
            },
            onSidebarMouseOver() {
                if (this.menuMode === 'sidebar' && !this.sidebarStatic) {
                    this.sidebarActive = this.isDesktop()
                    setTimeout(() => {
                        this.pinActive = this.isDesktop()
                    }, 200)
                }
            },
            onSidebarMouseLeave() {
                if (this.menuMode === 'sidebar' && !this.sidebarStatic) {
                    setTimeout(() => {
                        this.sidebarActive = false
                        this.pinActive = false
                    }, 250)
                }
            },
            hideOverlayMenu() {
                this.overlayMenuActive = false
                this.staticMenuMobileActive = false
            },
            onMenuButtonClick(event) {
                this.menuClick = true

                if (this.isOverlay()) {
                    this.overlayMenuActive = !this.overlayMenuActive
                }

                if (this.isDesktop()) {
                    this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive
                } else {
                    this.staticMenuMobileActive = !this.staticMenuMobileActive
                }

                event.preventDefault()
            },
            onTopbarItemClick(event) {
                this.topbarItemClick = true
                this.topbarMenuActive = !this.topbarMenuActive
                this.hideOverlayMenu()
                event.preventDefault()
            },
            onRightMenuButtonClick() {
                this.rightMenuClick = true
                this.rightMenuActive = true
            },
            onRightMenuClick() {
                this.rightMenuClick = true
            },
            onMenuClick() {
                this.menuClick = true
            },
            onRootMenuItemClick() {
                this.menuActive = !this.menuActive
            },
            onMenuItemClick(event) {
                if (!event.item.items) {
                    this.hideOverlayMenu()
                    EventBus.emit('reset-active-index')
                }

                if (!event.item.items && (this.isHorizontal() || this.isSlim())) {
                    this.menuActive = false
                }
            },
            onChangeMenuMode(menuMode) {
                this.menuMode = menuMode
                this.overlayMenuActive = false
            },
            onConfigClick() {
                this.configClick = true
            },
            onConfigButtonClick(event) {
                this.configActive = !this.configActive
                this.configClick = true
                event.preventDefault()
            },
            onChangeRightMenuActive(active) {
                this.rightMenuActive = active
            },
            onChangeMenuTheme(theme) {
                this.$emit('change-menu-theme', theme)
            },
            onChangeComponentTheme(theme) {
                this.$emit('change-component-theme', theme)
            },
            onChangeColorScheme(scheme) {
                this.$emit('change-color-scheme', scheme)
            },
            onToggleMenu(event) {
                this.menuClick = true

                if (this.overlayMenuActive) {
                    this.overlayMenuActive = false
                }

                if (this.sidebarActive) {
                    this.sidebarStatic = !this.sidebarStatic
                }

                event.preventDefault()
            },
            onChangeActiveInlineMenu() {
                this.activeInlineProfile = !this.activeInlineProfile
            },
            blockBodyScroll() {
                if (document.body.classList) {
                    document.body.classList.add('blocked-scroll')
                } else {
                    document.body.className += ' blocked-scroll'
                }
            },
            unblockBodyScroll() {
                if (document.body.classList) {
                    document.body.classList.remove('blocked-scroll')
                } else {
                    document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ')
                }
            },
            isHorizontal() {
                return this.menuMode === 'horizontal'
            },
            isSlim() {
                return this.menuMode === 'slim'
            },
            isOverlay() {
                return this.menuMode === 'overlay'
            },
            isStatic() {
                return this.menuMode === 'static'
            },
            isSidebar() {
                return this.menuMode === 'sidebar'
            },
            isDesktop() {
                return window.innerWidth > 991
            },
            isMobile() {
                return window.innerWidth <= 991
            },
            subscribeMqtt() {
                const mqttHook = this.$mqttHook
                console.log('mqttHook', mqttHook)
                const useSecure = process.env.NODE_ENV == 'production' || process.env.VUE_APP_USE_HTTPS === 'true'
                const wss = useSecure ? 'wss' : 'ws'
                const wssHost = process.env.VUE_APP_WSS_SERVER_ADDRESS || process.env.VUE_APP_SERVER_ADDRESS
                const wssUrl = useSecure
                    ? `${wss}://${wssHost}`
                    : `${wss}://${process.env.VUE_APP_WSS_SERVER_IP + ':1884'}`
                console.log("mqtt wss url", {
                    VUE_APP_WSS_SERVER_ADDRESS: process.env.VUE_APP_WSS_SERVER_ADDRESS,
                    VUE_APP_SERVER_ADDRESS: process.env.VUE_APP_SERVER_ADDRESS,
                    VUE_APP_SERVER_IP: process.env.VUE_APP_SERVER_IP,
                    wssUrl
                })
                mqttHook.connect(wssUrl, {
                    clean: false,
                    keepalive: 60,
                    clientId: `mqtt_client_${Math.random().toString(16).substring(2, 10)}`,
                    connectTimeout: 4000,
                })

                mqttHook.registerEvent(
                    'on-connect', // mqtt status: on-connect, on-reconnect, on-disconnect, on-connect-fail
                    (topic, message) => {
                        if (!this.nickname) return
                        console.log('mqtt connected', topic, message)
                        mqttHook.subscribe(
                            [
                                `${this.nickname}/notifications`, // quando l'utente riceve una notifica
                                `/chat/post/+`, //
                                `/chat/topic/+`, //
                                '/chat/post/+/readings', // quando un utente legge un messaggio (il + è il postID)
                                '/chat/post/+/status', // quando lo stato di un messaggio cambia (il + è il postID)
                                '/chat/post/+/comments/readings', // quando un utente legge un commento (il + è il postID)
                            ],
                            2,
                            undefined,
                            (err, granted) => {
                                console.log(`subscribed to ${this.nickname}/notifications`, granted)
                            }
                        )
                    }
                )
            },
            filterMenuByRuolo(menuItems, Ruolo) {
                const username = this.nickname; // Ottiene lo username dal token
                
                const filteredMenu = menuItems.filter(item => {
                    if (item.items) {
                        delete item.Ruolo
                        // caso in cui l'elemento è un gruppo di menu
                        item.items = this.filterMenuByRuolo(item.items, Ruolo)
                        return item.items.length > 0
                    } else {
                        delete item.Ruolo
                        
                        // Controlla se esiste una configurazione specifica per utente
                        const userPermissions = routeUserPermissionsMap[item.to];
                        if (userPermissions) {
                            const hasRoleAccess = userPermissions.roles.some(r => r === Ruolo);
                            const isSpecificUser = userPermissions.specificUsers.includes(username);
                            return hasRoleAccess || isSpecificUser;
                        }
                        
                        // Sistema tradizionale (solo ruoli)
                        if (!routePermissionsMap[item.to]) return true
                        return routePermissionsMap[item.to].some(r => r === Ruolo)
                    }
                })
                return filteredMenu
            },

        },
        created() {
            if (this.ruolo) {
                this.menu = this.filterMenuByRuolo(this.menu, this.ruolo)
            }
        },
        mounted() {
            this.subscribeMqtt()
        },

        computed: {
            layoutContainerClass() {
                return [
                    'layout-wrapper',
                    {
                        'layout-static': this.menuMode === 'static',
                        'layout-overlay': this.menuMode === 'overlay',
                        'layout-overlay-active': this.overlayMenuActive,
                        'layout-slim': this.menuMode === 'slim',
                        'layout-horizontal': this.menuMode === 'horizontal',
                        'layout-active': this.menuActive,
                        'layout-mobile-active': this.staticMenuMobileActive,
                        'layout-sidebar': this.menuMode === 'sidebar',
                        'layout-sidebar-static': this.menuMode === 'sidebar' && this.sidebarStatic,
                        'layout-static-inactive': this.staticMenuDesktopInactive && this.menuMode === 'static',
                        'p-ripple-disabled': this.$primevue.config.ripple === false,
                    },
                ]
            },
            token() {
                const token = localStorage.getItem('token')
                if (token) return VueJwtDecode.decode(localStorage.getItem('token'))
                return null
            },
            nickname() {
                return this.token?.nickname
            },
            nome() {
                return this.token?.nome
            },
            cognome() {
                return this.token?.cognome
            },
            ruolo() {
                return this.token?.ruolo
            },
            sede() {
                return this.token?.sede
            },
            email() {
                return this.token?.email
            },
        },
        components: {
            AppTopBar,
            AppMenu,
            AppRightMenu,
            AppFooter,
            // AppBreadcrumb,
            AppConfig,
        },
    }
</script>
<style>
    .layout-main-content {
        padding-bottom: 0 !important;
    }

    /* Rich text editor */
    .p-editor-container .p-editor-content .ql-editor {
        background-color: rgb(245, 245, 245) !important;
    }

    .p-chips-multiple-container {
        width: 100% !important;
    }
</style>
